<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>成功了！我們回到現實了！</npc>
              <npc :npc-id="0">雖然還不確定是哪個時空的『現實』呢。</npc>
              <npc :npc-id="1" right>呂善安，你看這裡！</npc>

              <story-image :src="require(`@/assets/images/pics/第6章_1-1_往開化寺紙條.jpg`)"></story-image>
              <!-- （圖片：怪盜的紙條） -->

              <npc :npc-id="0">嗯，接著要去開化寺嗎⋯⋯</npc>
              <npc :npc-id="1" right>下面寫的『Negative慈雲』是什麼意思啊？</npc>
              <npc :npc-id="0">現在還不清楚，或許到開化寺就知道了。</npc>
              <npc :npc-id="1" right>呂善安，這個開化寺也是跟賴和有關的地方嗎？</npc>
              <npc :npc-id="0">微妙呢，目前我們經過的地方，都跟賴和先生的生平有關，但開化寺不同，只在賴和先生的一篇小說中出現過，叫〈善訟的人的故事〉——嗯？等一下⋯⋯</npc>
              <npc :npc-id="1" right>怎麼了？</npc>
              <npc :npc-id="0">小蘇，你有帶著怪盜的名片嗎？</npc>
              <npc :npc-id="1" right>有啊！</npc>

              <story-image :src="require(`@/assets/images/pics/第6章_1-2_名片與簽名.jpg`)"></story-image>
              <!-- （圖片：怪盜的名片） -->

              <npc :npc-id="0">原來如此，這個奇怪的符號是⋯⋯</npc>
              <npc :npc-id="1" right>你想到什麼了？</npc>
              <npc :npc-id="0">如果這符號是『簽名』，或許暗示了怪盜的身分。</npc>
              <npc :npc-id="1" right>咦？所以你知道怪盜的身分了！</npc>
              <npc :npc-id="0">不完全。但我相信只要去開化寺，大部分的問題應該都會獲得解答。</npc>
              <npc :npc-id="1" right>呂善安，這真的不是陷阱嗎？我已經搞不懂了！怪盜救了我們，他到底想做什麼？</npc>
              <npc :npc-id="0">確實還有很多謎團呢，不過剛剛被逮捕時，時間警察已經提供了很多線索。</npc>
              <npc :npc-id="1" right>什麼？呂善安，你到底知道多少了？</npc>
              <npc :npc-id="0">整理一下吧。一開始我們以為怪盜偷走臺灣文學館存在的歷史，是因為在解開怪盜留下的謎題後，臺灣文學館就消失了。然而真是如此嗎？</npc>
              <npc :npc-id="1" right>難道不是嗎？</npc>
              <npc :npc-id="0">我們繼續看下去吧。原本我不懂為何怪盜不斷出題，引導我們到跟賴和先生有關的地點，但從時間警察說的話，我們可以推測出，怪盜是透過『空間』引導我們『回想』起跟賴和先生有關的『歷史』，也就是時間警察說的『證明』。</npc>
              <npc :npc-id="1" right>確實，時空警察好像是來自賴和沒什麼名氣的歷史，他也想維護那個歷史——啊，所以你才說怪盜跟時間警察作對，是要偷回賴和為人所知的歷史嗎？</npc>
              <npc :npc-id="0">對，但這就跟我們一開始的認知產生了矛盾；為何會這樣？我認為原因很簡單：我們跟怪盜的『出發點』不同。</npc>
              <npc :npc-id="1" right>出發點？</npc>
              <npc :npc-id="0">對。現在確實存在兩個時空，一個時空裡『賴和先生沒有名氣』，就叫α時空好了，另一個時空則是『賴和先生是臺灣新文學之父』，就叫β時空好了。小蘇，你覺得怪盜是來自哪個時空？</npc>

              <story-image :src="require(`@/assets/images/pics/第6章_1-3_平行世界圖表1-1.jpg`)"></story-image>
              <!-- （解說圖表1） -->

              <npc :npc-id="1" right>既然怪盜打算讓賴和重新成為新文學之父，那應該是來自α時空吧？畢竟β時空裡賴和本來就是新文學之父，根本不用改變啊。</npc>
              <npc :npc-id="0">對。根據時間警察的說法，怪盜是找人來『證明』賴和先生是臺灣新文學之父，但問題來了，在α時空裡，賴和先生沒沒無聞，真的有人能『證明』賴和先生的生平與重要性嗎？</npc>
              <npc :npc-id="1" right>啊！難道說，為了『證明』，怪盜居然從β時空裡尋找適合的人嗎？</npc>
              <npc :npc-id="0">沒錯。說到這種事，還有比我文學偵探呂善安更適合的人嗎？雖然不知道怪盜穿越時空的原理，但他肯定是從α時空穿越道β時空，偷走賴和面具，透過臺灣文學館把我們引誘到小逸堂。</npc>

              <story-image :src="require(`@/assets/images/pics/第6章_1-4_平行世界圖表1-2.jpg`)"></story-image>
              <!-- （解說圖表2） -->

              <npc :npc-id="1" right>為什麼要把我們引誘到小逸堂？</npc>
              <npc :npc-id="0">我想是因為，小逸堂是個方便穿越時空的地點吧？在小逸堂那裡，怪盜將我們『偷』到了α時空，所以被偷走的是我們，而不是臺灣文學館！因為我們來自不同時空，才會誤以為臺灣文學館消失了。</npc>
              <npc :npc-id="1" right>原來如此！但為何怪盜要做這些事？我是說，既然他是另一個時空的人，為何想把他的時空變得跟我們的時空一樣？</npc>
              <npc :npc-id="0">這我也還不清楚。不過，開化寺一定有答案。</npc>

              <map-link name="開化寺" map-id="n9b8LEXmTKFpr2Dq7"/>

              <move-to-stage-btn link="前往開化寺">前往開化寺</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage6_1',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第六章 - 1',
      isQuestion: false,
      stageId: 'reality',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
